import { TrendsType } from "reedy-data/models";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { limit, query, where, orderBy } from "firebase/firestore";
import { TabHeader } from "components/TabHeader";
import { SearchTermsAmazonEmpty } from "../table/SearchTermsAmazonEmpty";
import { SearchTermsAmazonPreHeader } from "./SearchTermsAmazonPreHeader";
import { SearchTermsAmazonTable } from "./SearchTermsAmazonTable";
import { getSearchTermCollection } from "../../../integrations/firebase/collections/searchTerms";

export const SearchTermsAmazonPage = () => {
  const { t } = useTranslation(["searchTerms"]);

  const [countryCode, setCountryCode] = useState<string>("DE");

  const [weeklyDocs = [], isLoading] = useCollectionData(
    query(
      getSearchTermCollection(),
      where("market", "==", countryCode === "GB" ? "UK" : countryCode),
      orderBy("updated_at", "desc"),
      limit(1),
    ),
  );

  const latestWeeklyDoc = weeklyDocs[0];
  const searchTerms = latestWeeklyDoc?.terms || [];

  const isEmptyAmazon = !latestWeeklyDoc && !isLoading;

  return (
    <div className="space-y-8">
      <TabHeader
        title={t("searchTerms:header.title")}
        subtitle={t("searchTerms:header.subtitle")}
      />
      <div className="space-y-4 text-left">
        <SearchTermsAmazonPreHeader
          countryCode={countryCode}
          onCountryCodeChange={setCountryCode}
          countryCodes={["DE", "GB", "US"]}
          trends={[TrendsType.GOOGLE, TrendsType.AMAZON]}
          week={latestWeeklyDoc?.week}
        />
        {isEmptyAmazon ? (
          <SearchTermsAmazonEmpty />
        ) : (
          <SearchTermsAmazonTable
            searchTerms={searchTerms}
            isLoading={isLoading}
          />
        )}
      </div>
    </div>
  );
};
